import { useEffect } from "react";
import { motion } from "framer-motion";
import { EASE, CHAPTERS, scrollToSection } from "@/App";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Chapter from "@/components/Chapter";
import Secteurs from "@/components/Secteurs";
import QuoteForm from "@/components/QuoteForm";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";

export default function HomePage() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      const t = setTimeout(() => scrollToSection(id), 700);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />

        <section
          id="apropos"
          data-testid="manifesto-section"
          className="py-32 md:py-44 max-w-7xl mx-auto px-6 md:px-10"
        >
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: EASE }}
            className="uppercase tracking-[0.25em] text-xs text-[#D1BFAE]"
          >
            Rénovation de A à Z
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.2, ease: EASE, delay: 0.1 }}
            className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] mt-8 max-w-4xl text-[#F9F9F9]"
          >
            De la démolition à la dernière jointée de céramique, une seule
            équipe. <em className="text-[#D1BFAE]">Un seul engagement.</em>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: EASE, delay: 0.2 }}
            className="text-[#C4C9CE] text-base sm:text-lg leading-relaxed mt-8 max-w-2xl"
          >
            Démolition, plomberie, électricité, céramique, vanité, finitions —
            Salle de Bain Expert prend en charge votre projet complet, sans
            sous-traitance ni mauvaise surprise. Fièrement au service de la
            Rive-Nord, des Laurentides et de Saint-Jérôme.
          </motion.p>
        </section>

        <section id="realisations" data-testid="realisations-section">
          {CHAPTERS.map((c, i) => (
            <Chapter key={c.id} {...c} reverse={i % 2 === 1} />
          ))}
        </section>

        <Secteurs />
        <QuoteForm />
        <Newsletter />
      </main>
      <Footer />
    </>
  );
}
